/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect} from 'react'
import PropTypes from 'prop-types'
import { ContactAddress } from '../../components'
import { Container } from './index.styled'

const MenuContactComponent = React.memo(({ margintop, data }) => {

  const [ countryInfos, setCountryInfos ] = useState([])
  const [ isOpen, setIsOpen ] = useState(-1);

  const setOpenClose = (id) => isOpen === id ? setIsOpen(-1): setIsOpen(id);

  useEffect(() => {
    setCountryInfos(data);
  }, [])

  return (
    <Container style={{marginTop: margintop}}>
      {countryInfos.map(info => {
        return(
          <ContactAddress 
            key={info?.id} 
            data={info} 
            isOpen={info?.id === isOpen} 
            setOpenClose={setOpenClose}
          />
        )
      })}
    </Container>
  )
})

MenuContactComponent.propTypes = {
  margintop: PropTypes.number,
  data: PropTypes.array,
}

MenuContactComponent.defaultProps = {
  margintop: 0,
  data: {},
}

export default MenuContactComponent
